import definitions from "../../../definitions";
import Tilemap from "../../Tilemap";
import EnemyButterfly from "./EnemyButterfly";
import EnemyChicken from "./EnemyChicken";
import EnemyCrab from "./EnemyCrab";
import EnemyCrabHostile from "./EnemyCrabHostile";
import EnemyDuckling from "./EnemyDuckling";
import EnemyFirefly from "./EnemyFirefly";
import EnemySimonSays from "./EnemySimonSays";
import EnemySnake from "./EnemySnake";
import EnemySnapperPlant from "./EnemySnapperPlant";
import EnemySpider from "./EnemySpider";
import EnemySpikeTrap from "./EnemySpikeTrap";
import EnemySwanling from "./EnemySwanling";
import EnemyWorm from "./EnemyWorm";
import EnemySquirrel from "./EnemySquirrel";
import EnemyExplodingMushroom from "./EnemyExplodingMushroom";
import EnemyBouncingToad from "./EnemyBouncingToad";

export default class EnemyFactory {
    /**
     * @param {string} id
     * @param {object} [properties={}]
     * @returns {Enemy}
     */
    static create(id, properties = {}) {
        switch (id) {
            case definitions.ENEMY_ID.BUTTERFLY: {
                return new EnemyButterfly();
            }
            case definitions.ENEMY_ID.BOUNCING_TOAD: {
                return new EnemyBouncingToad();
            }
            case definitions.ENEMY_ID.CHICKEN: {
                return new EnemyChicken();
            }
            case definitions.ENEMY_ID.CRAB: {
                return new EnemyCrab();
            }
            case definitions.ENEMY_ID.CRAB_HOSTILE: {
                return new EnemyCrabHostile();
            }
            case definitions.ENEMY_ID.DUCKLING: {
                return new EnemyDuckling();
            }
            case definitions.ENEMY_ID.EXPLODING_MUSHROOM: {
                return new EnemyExplodingMushroom();
            }
            case definitions.ENEMY_ID.FLYING_SNAKE: {
                return new EnemySnake();
            }
            case definitions.ENEMY_ID.FIREFLY: {
                return new EnemyFirefly();
            }
            case definitions.ENEMY_ID.SIMON_SAYS: {
                return new EnemySimonSays();
            }
            case definitions.ENEMY_ID.SNAPPER_PLANT: {
                return new EnemySnapperPlant();
            }
            case definitions.ENEMY_ID.SPIDER: {
                return new EnemySpider();
            }
            case definitions.ENEMY_ID.SWANLING: {
                return new EnemySwanling();
            }
            case definitions.ENEMY_ID.SPIKE_TRAP: {
                const trap = new EnemySpikeTrap();
                trap.attackDelay = Tilemap.getCustomProperty("attackDelay", properties);
                trap.attackOffset = Tilemap.getCustomProperty("attackOffset", properties);
                return trap;
            }
            case definitions.ENEMY_ID.SQUIRREL: {
                return new EnemySquirrel();
            }
            case definitions.ENEMY_ID.WORM: {
                return new EnemyWorm();
            }
        }
        return null;
    }
}